import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {CustomerProjectionDto} from "../../api/sts";

export interface StsCustomerItem {
    label: string
    customerNumber: string
    id: string
}

const serviceApi = api.sts.api

function buildStsCustomerItem(item: CustomerProjectionDto): StsCustomerItem {
    return {
        label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
        customerNumber: `${item.customerNumber}`,
        id: `${item.customerId}`
    }
}

class StsCustomerStore {
    get items(): StsCustomerItem[] {
        return this._items;
    }

    set items(value: StsCustomerItem[]) {
        this._items = value;
    }

    private _items: StsCustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<StsCustomerItem[]> {
        const response = await catchApi(async () => serviceApi.findCustomers({query: query}))
        return (response?.data || []).map(item => buildStsCustomerItem(item))
    }

    async init() {
        const response = await catchApi(async () => serviceApi.findCustomers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }
}

const stsCustomerStore = new StsCustomerStore()

export {
    stsCustomerStore,
    buildStsCustomerItem,
}
